export const defaultConfig = {
  baseAPIUrl:
    process.env.NODE_ENV === "development"
      ? "https://posapi.orderart.com.au"
      : "https://posapi.orderart.com.au",
};

 export const ERROR_RECOVERY_CONFIG = {
  redirectOnError: true,
  redirectPath: '/dashboard',
  showToast: true,
  toastMessage: 'Something went wrong. Redirecting to dashboard...',
  preventLoop: true
};